import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";

// "Ma société": served by retail-erp (SocieteRestApi) through the gateway like the
// other societe calls. The company is always resolved server side from the user,
// no company id is ever sent.
class MyCompanyService {
  get() {
    return api.get("/retail/SocieteRestApi/myCompany/" + currentUserId());
  }
  update(company) {
    return api.put(
      "/retail/SocieteRestApi/myCompany/" + currentUserId(),
      company
    );
  }
  uploadLogo(file) {
    const formData = new FormData();
    formData.append("picture", file);
    return api.post(
      "/retail/SocieteRestApi/myCompany/logo/" + currentUserId(),
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
}

export default new MyCompanyService();
